// https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Number/toLocaleString
function toLocaleStringSupportsLocales() {
    let number = 0;
    try {
        number.toLocaleString('i');
    } catch (e) {
        return e.name === 'RangeError';
    }
    return false;
}

// https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Number/toLocaleString
function toLocaleStringSupportsOptions() {
    return !!(
        typeof Intl === 'object' &&
        Intl &&
        typeof Intl.NumberFormat === 'function'
    );
}

const isLocaleFormattingSupportedInBrowser =
    toLocaleStringSupportsLocales() && toLocaleStringSupportsOptions();

export const formatPrice = price => {
    if (!isLocaleFormattingSupportedInBrowser) {
        return typeof price !== 'number'
            ? `${parseInt(price)} kr`
            : `${price} kr`;
    }

    const format = formatMe =>
        formatMe.toLocaleString('sv-SE', {
            symbol: ' kr',
            symbolPosition: 'end',
            decimal: ',',
            comma: '.'
        });
    return typeof price !== 'number'
        ? `${format(parseInt(price))} kr`
        : `${format(price)} kr`;
};

export const formatNumber = number => {
    if (!isLocaleFormattingSupportedInBrowser) {
        return typeof number !== 'number' ? `${parseInt(number)}` : `${number}`;
    }

    const format = formatMe => formatMe.toLocaleString('sv-SE');

    return number !== undefined
        ? typeof number !== 'number'
            ? format(parseInt(number))
            : format(number)
        : '';
};

export const formatUserRating = rating => {
    if (!rating) return;
    const number = parseFloat(rating);
    if (number <= 0) return '0.0';
    if (number >= 5) return '5.0';
    return number.toFixed(1);
};
